export enum FormTypes {
    materials = 'materials',
    tools = 'tools',
}
